module.exports = __webpack_public_path__ + "Roboto-Medium.cf4d60bc0b1d4b231408.woff";


//////////////////
// WEBPACK FOOTER
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/assets/fonts/roboto/Roboto-Medium.woff
// module id = ../../../../../src/assets/fonts/roboto/Roboto-Medium.woff
// module chunks = styles